import React from 'react';

interface FilteredProductsModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  tableName?: string;
  filterType?: 'all' | 'brand' | 'category' | 'site' | 'discount' | string;
  filterValue?: string;
  title?: string;
  filters?: any;
}

const FilteredProductsModal: React.FC<FilteredProductsModalProps> = ({ 
  isOpen = false, 
  onClose = () => {},
  title = "Productos Filtrados"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="text-gray-600 mb-4">Vista de productos filtrados - En desarrollo</p>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default FilteredProductsModal;
